import React from 'react'
import './style.css'

export default function Hero() {
  return (
    <div className='Hero'>
      <span>
        <div className='Hero_Left'>
          <h2>I'm Jeswin<br/><b>Full stack developer</b></h2>
          <h3>Specialize in web and mobile application development</h3>
          <a href='tel:+919626429355'>Enquire Now</a>
        </div>
        <div className='Hero_Right'/>
      </span>
      <div className='Hero_Design1'/>
      <div className='Hero_Design2'/>
    </div>
  )
}
